var React = require('react');

function Doge (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M63.38 62.287c-1.079 2.484-2.57 4.222-4.476 5.219C57 68.502 53.793 69 49.286 69h-5.163a.122.122 0 0 1-.123-.122V31.122c0-.067.055-.122.123-.122h5.258c5.587 0 9.587 1.36 12 4.08C63.793 37.8 65 42.845 65 50.213c0 5.567-.54 9.591-1.62 12.074M85.273 36.2c-1.152-4.265-3.009-8.005-5.57-11.22-2.56-3.215-5.8-5.683-9.72-7.401C66.06 15.859 60.916 15 54.548 15H14.124a.123.123 0 0 0-.124.123V30.73c0 .067.055.123.124.123h7.992c.068 0 .123.055.123.123v38a.123.123 0 0 1-.123.124h-7.432a.123.123 0 0 0-.123.123v15.654c0 .068.055.123.123.123h39.864c3.871 0 8.192-.636 12.962-1.91 3.488-.923 6.752-2.777 9.793-5.563 3.04-2.785 5.416-6.238 7.129-10.361C86.144 63.044 87 57.242 87 49.76c0-4.775-.576-9.295-1.728-13.56"}));
}

Doge.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = Doge;

Doge.default = Doge;
